import {
  AddressType,
  type GeocodeResult,
} from '@googlemaps/google-maps-services-js'

export function parseAddressComponents(
  googleMapsResult: google.maps.places.PlaceResult | GeocodeResult,
) {
  const {
    address_components: addressComponents,
    formatted_address: formattedAddress,
  } = googleMapsResult

  if (!addressComponents || !formattedAddress) {
    return null
  }
  const zip = addressComponents.find((component) =>
    component.types.includes(AddressType.postal_code),
  )?.long_name

  if (!zip) {
    return null
  }

  const streetNumber = addressComponents.find((component) =>
    component.types.includes(AddressType.street_number),
  )?.long_name
  const streetAddress = addressComponents.find((component) =>
    component.types.includes(AddressType.street_address),
  )?.long_name
  const streetName = addressComponents.find(
    (component) => component.types.includes(AddressType.route), // this is actually street name
  )?.long_name
  const aptOrUnit = addressComponents.find(
    (component) => component.types.includes(AddressType.subpremise), // this is like apt or unit or suite
  )?.long_name
  const city = addressComponents.find(
    (component) =>
      component.types.includes(AddressType.sublocality_level_1) ||
      component.types.includes(AddressType.sublocality) ||
      component.types.includes(AddressType.locality),
  )?.long_name
  const country = addressComponents.find((component) =>
    component.types.includes(AddressType.country),
  )?.long_name
  const countryCode = addressComponents.find((component) =>
    component.types.includes(AddressType.country),
  )?.short_name
  const state = addressComponents.find(
    (component) =>
      component.types.includes(AddressType.administrative_area_level_1) ||
      component.types.includes(AddressType.locality),
  )?.long_name

  // 123 Willems Street
  const addressLineOne = [
    streetNumber ?? '',
    streetAddress ?? '',
    streetName ?? '',
  ]
    .filter(Boolean)
    .join(' ')
    .trim()

  // 123 Willems Street, Unit 3
  const combinedAddress = [addressLineOne, aptOrUnit].filter(Boolean).join(', ')

  return {
    addressLineOne: combinedAddress, // we only have addressLine1 for EMR consent so shove everything in it
    addressLineTwo: null,
    city: city ?? null,
    country: country ?? null,
    countryCode,
    formattedAddress,
    state: state ?? null,
    zip: zip,
  }
}
